import { create } from 'zustand';

type ViewType = 'content' | 'profile';

interface ContentViewState {
  currentView: ViewType;
  setCurrentView: (view: ViewType) => void;
  toggleView: () => void;
}

export const useContentViewStore = create<ContentViewState>((set, get) => ({
  currentView: 'content',
  setCurrentView: (view: ViewType) => set({ currentView: view }),
  toggleView: () => set((state) => ({ 
    currentView: state.currentView === 'content' ? 'profile' : 'content' 
  }))
})); 